import { createAction } from 'redux-actions';

export const requestGetRelatedEntitiesDataAction = createAction(
  'REQUEST/GET_RELATED_ENTITIES_DATA',
);
export const requestGetRelatedEntitiesCompleteListDataAction = createAction(
  'REQUEST/GET_RELATED_ENTITIES_COMPLETE_LIST_DATA',
);
export const requestGetContactDataAction = createAction('REQUEST/GET_CONTACT_DATA');
